import type { RootState } from "../store";

// state.endToEndTest is never undefined, we only fallback to {} so the test suite
// doesn't need to define the reducer
export const selectEndToEndTest = (state: RootState) =>
  state.endToEndTest || {};
